"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImage = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductImage = () => {
  const {
    image,
    name
  } = (0, _contexts.useSearchPreviewProduct)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const imagesVariants = (0, _react.useMemo)(() => ({
    url: image ?? '',
    imageFormat: 'WebP',
    backgroundColor: theme.palette.grey[100],
    imageSizeMultiplier: 2,
    params: [{
      width: _constants.PRODUCT_IMAGE_SIZE,
      height: _constants.PRODUCT_IMAGE_SIZE,
      quality: 90
    }]
  }), [image, theme]);
  if (!image) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.ImagePlaceholder, {
        testId: getTestId(_constants.PRODUCT_IMAGE_PLACEHOLDER),
        height: _constants.PRODUCT_IMAGE_SIZE,
        width: _constants.PRODUCT_IMAGE_SIZE
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Image, {
      "data-testid": getTestId(_constants.PRODUCT_IMAGE),
      alt: name,
      src: image,
      srcSet: (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)),
      sizes: `${_constants.PRODUCT_IMAGE_SIZE}px`
    })
  });
};
exports.ProductImage = ProductImage;
